import { createNamedContext } from '@utils';
import { CSV, Tagging } from './interfaces';

export const CSVFieldMappingContext = createNamedContext<CSV.FieldMappingContextValue>(undefined, 'Group.Contacts.Import.CSV.FieldMapping.Context');
export const CSVFileContext = createNamedContext<CSV.FileContextValue>(undefined, 'Group.Contacts.Import.CSV.File.Context');
export const CSVQueriesContext = createNamedContext<CSV.QueriesContextValue>(undefined, 'Group.Contacts.Import.CSV.Queries.Context');

export const TaggingAutoSuggestContext = createNamedContext<Tagging.AutoSuggestContextValue>(undefined, 'Group.Contacts.Import.Tagging.Search.Context');